/// <amd-module name="CodeCoverage/Timeline/Stores/CodeCoverageTimelineStore" />
import { CodeCoverageActionHub, CodeCoverageSummaryData } from 'CodeCoverage/Common/Actions/CodeCoverageActionHub';
import { ICodeCoverageTimelineSummaryProps } from 'CodeCoverage/Timeline/Components/CodeCoverageTimelineSummary';
import { Store } from 'VSS/Reflux/Store';


export interface ICodeCoverageTimelineForBuildState {
    shouldShowSummary: boolean,
    codeCoverageTimelineSummaryProps: ICodeCoverageTimelineSummaryProps[]
}

export class CodeCoverageTimelineStore extends Store {
	constructor(private changeEvent: string, private _actionsHub: CodeCoverageActionHub) {
		super(changeEvent);
        this._initialize();
    }
    
    public getState(): ICodeCoverageTimelineForBuildState {
        return this._state;
    }
    
    private _initialize(): void {
        this._state = this._getDefaultState();
        this._actionsHub.initializeCodeCodeCoverageSummary.addListener(this._initializeCodeCoverageSummary);
    }

    private _getDefaultState(): ICodeCoverageTimelineForBuildState {
        return {
            shouldShowSummary: false,
            codeCoverageTimelineSummaryProps: []
        } as ICodeCoverageTimelineForBuildState;
    }

    private _initializeCodeCoverageSummary = (summaryData: CodeCoverageSummaryData)  => { 
        this._state.shouldShowSummary = summaryData.timelineSummaryData.length > 0;
        this._state.codeCoverageTimelineSummaryProps = summaryData.timelineSummaryData;
        this.emitChanged();
    }

    private _state: ICodeCoverageTimelineForBuildState;
}
